import * as allIcons from '@sloyd/icons';
import { Wrapper } from './Playback.style';

export type PlaybackProps = {
  isRunning: boolean;
  onAction: (actionType: string, verb: string) => void;
};

export function Playback(props: PlaybackProps) {
  const { isRunning } = props;

  function renderInner() {
    if (isRunning) {
      return (
        <allIcons.IconPlayerPause size={30} onClick={() => props.onAction('ANIMATION', 'pause')} />
      );
    } else {
      return (
        <allIcons.IconPlayerPlay size={30} onClick={() => props.onAction('ANIMATION', 'play')} />
      );
    }
  }
  return (
    <Wrapper className='Playback-wrapper' data-testid='Playback-wrapper'>
      {renderInner()}
    </Wrapper>
  );
}

export default Playback;
